import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Page.css';
import './Zdjecia.css';

const Zdjecia = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const { t } = useTranslation();

  // Helper to import all images from src/assets/portrait at build time
  const importAll = (r) => r.keys().map((key, idx) => ({ id: idx + 1, src: r(key) }));
  let portraitImages = [];
  try {
    // Supported extensions: .png, .jpg, .jpeg, .webp, .gif
    portraitImages = importAll(require.context('../assets/portrait', false, /\.(png|jpe?g|webp|gif)$/));
  } catch (e) {
    // If the folder doesn't exist or is empty, keep an empty list
    portraitImages = [];
  }

  // Photo categories
  const photoCategories = [
    // {
    //   id: 'scenic',
    //   title: t('photos.onStage'),
    //   photos: [
    //     {
    //       id: 1,
    //       src: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    //       alt: 'Występ operowy',
    //       caption: 'W roli w operze "La Traviata"'
    //     },
    //     {
    //       id: 2,
    //       src: 'https://images.unsplash.com/photo-1511192336575-5a79af67a629?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    //       alt: 'Kostium sceniczny',
    //       caption: 'W kostiumie do "Carmen"'
    //     },
    //     {
    //       id: 3,
    //       src: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    //       alt: 'Portret sceniczny',
    //       caption: 'Portret w roli'
    //     }
    //   ]
    // },
    {
      id: 'portrait',
      title: t('photos.portraits'),
      photos: portraitImages.map((img) => ({ id: img.id, src: img.src, alt: '', caption: '' }))
    },
    // {
    //   id: 'rehearsal',
    //   title: t('photos.rehearsal'),
    //   photos: [
    //     {
    //       id: 6,
    //       src: 'https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    //       alt: 'Próba wokalna',
    //       caption: 'Podczas próby wokalnej'
    //     },
    //     {
    //       id: 7,
    //       src: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    //       alt: 'Backstage',
    //       caption: 'Za kulisami'
    //     }
    //   ]
    // }
  ];

  const openModal = (photo) => {
    setSelectedImage(photo);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="page">
      <div className="page-container">
        <div className="page-header">
          <h1>{t('photos.title')}</h1>
          <p className="page-subtitle">{t('photos.subtitle')}</p>
        </div>
        
        <div className="page-content">
          {photoCategories.map((category) => (
            <div key={category.id} className="photo-category">
              <h2 className="category-title">{category.title}</h2>
              <div className="photo-grid">
                {category.photos.map((photo) => (
                  <div 
                    key={photo.id} 
                    className="photo-item"
                    onClick={() => openModal(photo)}
                  >
                    <img 
                      src={photo.src} 
                      alt={photo.alt}
                      className="photo-thumbnail"
                      loading="lazy"
                      decoding="async"
                    />
                    <div className="photo-overlay">
                      <p className="photo-caption">{photo.caption}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal for full-size image */}
      {selectedImage && (
        <div className="photo-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>&times;</button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="modal-image"
            />
            <p className="modal-caption">{selectedImage.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Zdjecia;
